import { defineStore } from 'pinia';
import { DataTableHeader } from 'vuetify';
import { ref, set } from 'vue';

export interface CfsTableHeaders extends DataTableHeader {
  active: boolean;
  selected: boolean;
  exportHeader?: string;
  showColumnsMenu?: boolean;
  hideOnMobile?: boolean;
}

export const useCfsTableStore = defineStore('cfs-table', () => {
  const headers = ref<Record<string, CfsTableHeaders[]>>({});

  const toggleTableHeaders = ({ key, value }: { key: string; value: CfsTableHeaders[] }) => {
    set(headers.value, key, value);
  };

  const initTableHeaders = ({ key, value }: { key: string; value: CfsTableHeaders[] }) => {
    if (!headers.value[key]) {
      toggleTableHeaders({ key, value });
      return;
    }

    /** merge cached relevant data with new */
    for (const newHeader in value) {
      const index = headers.value[key].findIndex((e) => e.value == value[newHeader].value);
      /** In case header was not found we just ignore it */
      if (index === -1) {
        continue;
      }
      /** In case header is found we make sure all fields except active and selected are up to what was supplied */
      value[newHeader].active = headers.value[key][index].active;
      value[newHeader].selected = headers.value[key][index].selected;
    }
    toggleTableHeaders({ key, value });
  };

  return {
    headers,
    initTableHeaders,
    toggleTableHeaders,
  };
});
